import { EmployeeNameFormat } from 'typings/enums';
import { observable, computed, action, makeObservable } from 'mobx';

const EmployeeNameFormatOptions: IOption[] = [
    {
        value: EmployeeNameFormat.FirstName,
        text: 'First Name'
    },
    {
        value: EmployeeNameFormat.FirstNameLastName,
        text: 'First Name Last Name'
    },
    {
        value: EmployeeNameFormat.FirstNameMiddleInitialLastName,
        text: 'First Name Middle Initial Last Name'
    },
    {
        value: EmployeeNameFormat.LastNameFirstName,
        text: 'Last Name First Name'
    },
    {
        value: EmployeeNameFormat.LastNameFirstNameMiddleInitial,
        text: 'Last Name First Name Middle Initial'
    }
];

export class EmployeeFormatConfiguration  {
    @observable _employeeNameSortFormat: EmployeeNameFormat;
    employeeNameFormatOptions: IOption[];

    constructor(sortFormat: EmployeeNameFormat) {
        makeObservable(this);
        this._employeeNameSortFormat = sortFormat;
        this.employeeNameFormatOptions = EmployeeNameFormatOptions;
    }

    @computed
    get employeeNameSortFormat(): EmployeeNameFormat {
        return this._employeeNameSortFormat;
    }

    @action
    setEmployeeNameSortFormat(employeeNameFormat: EmployeeNameFormat): void {
        this._employeeNameSortFormat = employeeNameFormat;
    }
}